export function formatAddress(address = {}) {
  let formatted = '';

  if (address.street) {
    formatted = address.street;
  }
  if (address.streetNo) {
    formatted = `${formatted} ${address.streetNo},`;
  }
  if (address.city) {
    formatted = `${formatted} ${address.city}`;
  }
  if (address.postalCode) {
    formatted = `${formatted}, ${address.postalCode}`;
  }

  return formatted;
}

export function getAddressTypeInfo(type) {
  switch (type) {
    case 'work':
      return { label: 'Εργασία' };
    case 'other':
      return { label: 'Άλλο' };
    default:
      return { label: 'Σπίτι' };
  }
}

export default { formatAddress, getAddressTypeInfo };
